import { default_get, default_post } from "../requests";

export function getPaasPlans() {
    return default_get('/paas/plan/all')
}

export function getPaasPlanSolution(_id) {
    return default_get(`/paas/plan/solution?id=${_id}`)
}

export function thereArePlansInQueue() {
    return default_get('/paas/plan/thereArePlansInQueue')
}

export function updatePlan(_plan) {
    return default_post({..._plan}, '/paas/plan/update')
}

export function deletePlan(_plan) {
    return default_post({..._plan}, '/paas/plan/delete')
}